// extracted by mini-css-extract-plugin
export default {"platformSelect":"PlatformSelect_platformSelect__cfXQ8","platformOption":"PlatformSelect_platformOption__RYDXi","fieldError":"PlatformSelect_fieldError__QUwGk"};